export default {
	EmailReceiveAlerts: function(state) {
		return state.EmailReceiveAlerts;
	},
	EmailReceiveAlert: function(state) {
		return state.EmailReceiveAlert;
	},
	Total: function(state) {
		return state.Total;
	}
};
